var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("售后订单")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: { formDataval: _vm.dialogClick },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("列表数据")]),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columns.config,
              typeStr: _vm.columns.type,
            },
          }),
          _vm.page.totalNum >= 8
            ? _c(
                "div",
                { staticClass: "page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.page.currentPage,
                      "page-sizes": [3, 5, 10, 20, 50],
                      "page-size": _vm.page.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.page.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.page, "currentPage", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.page, "currentPage", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }